import FinanceSerializer from './base';

export default class StripeConnection extends FinanceSerializer {}
